/*
 * Afuna Aromatics — Questions & Guidance support-center interactions.
 * Client-side only: local search/filter, category jump chips, and a
 * "Was this helpful?" acknowledgment. No network request, no analytics
 * pixel call (none is configured for this store), no personal data
 * collected or transmitted anywhere.
 */
(function () {
  'use strict';

  function normalize(text) {
    return (text || '').toLowerCase();
  }

  function initSearch() {
    var input = document.querySelector('[data-aa-qg-search]');
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-aa-qg-row]'));
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-aa-qg-group]'));
    var noResults = document.querySelector('[data-aa-qg-no-results]');
    if (!input || !rows.length) return;

    input.addEventListener('input', function () {
      var term = normalize(input.value).trim();
      var anyVisible = false;

      rows.forEach(function (row) {
        var text = normalize(row.textContent);
        var match = term === '' || text.indexOf(term) !== -1;
        row.hidden = !match;
        if (match) anyVisible = true;
      });

      groups.forEach(function (group) {
        var visibleRows = group.querySelectorAll('[data-aa-qg-row]:not([hidden])');
        group.hidden = term !== '' && visibleRows.length === 0;
      });

      if (noResults) {
        noResults.hidden = anyVisible || term === '';
      }
    });
  }

  function initHelpful() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-aa-qg-helpful]'));
    widgets.forEach(function (widget) {
      var buttons = widget.querySelectorAll('[data-aa-qg-helpful-btn]');
      var thanks = widget.querySelector('[data-aa-qg-helpful-thanks]');
      var buttonWrap = widget.querySelector('.aa-qg__helpful-buttons');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (buttonWrap) buttonWrap.hidden = true;
          if (thanks) thanks.hidden = false;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSearch();
      initHelpful();
    });
  } else {
    initSearch();
    initHelpful();
  }
})();
